import { createSystemLogsRoutes } from "@template/modules/systemLogsRoutes";

export const protectedRoutes = createSystemLogsRoutes({
  meta: {
    requiresAdmin: true,
    title: "Logs del Sistema",
    breadcrumb: ["Sistema", "Logs"],
    requiresAuth: true,
  },
});
